import React from 'react';
import type { ReactNode } from 'react';
import styled from 'styled-components';

const Operations = styled.div`
  text-align: right;
`;

type Props = {
  children: ReactNode;
};
/**
 * Компонент для отображения иконок операций в таблицах
 */
export default ({ children }: Props) => (
  <Operations onClick={e => e.stopPropagation()}>{children}</Operations>
);
